import { trigger, transition, style, animate } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

import { NotificationScheduler } from '@services/notification-scheduler.service';
import { NotificationStore } from '@services/notification-store.service';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="toast-stack" aria-live="polite">
      @for (toast of scheduler.activeToasts(); track toast.id) {
        <div [class]="['toast-card', toast.type]" @slideInOut (click)="store.dismiss(toast.id)">
          <div class="toast-content">
            <span class="message" [innerHTML]="toast.message"></span>
          </div>
          <button class="close-btn" (click)="$event.stopPropagation(); store.dismiss(toast.id)">
            <i class="now-ui-icons ui-1_simple-remove"></i>
          </button>
        </div>
      }
    </div>
  `,
  styles: [
    `
      .toast-stack {
        display: flex;
        flex-direction: column-reverse;
        gap: 12px;
        padding: 20px;
        pointer-events: none;
      }

      .toast-card {
        pointer-events: auto;
        min-width: 320px;
        max-width: 450px;
        padding: 16px 20px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-left: 5px solid transparent;
        cursor: pointer;
        transition: transform 0.2s ease;

        &:hover {
          transform: translateY(-2px);
        }

        &.success {
          background-color: rgb(46, 162, 82);
          .message {
            color: #fff;
          }
        }
        &.error {
          background-color: rgb(221, 63, 45);
          .message {
            color: #fff;
          }
        }
        &.info {
          background-color: rgb(82, 160, 212);
          .message {
            color: #fff;
          }
        }
        &.warn {
          background-color: rgb(242, 123, 38);
          .message {
            color: #fff;
          }
        }
      }

      .toast-content {
        flex: 1;
        margin-right: 12px;
        font-size: 14px;
        font-weight: 500;
        line-height: 1.4;
      }

      .close-btn {
        background: none;
        border: none;
        color: #fff;
        cursor: pointer;
        padding: 4px;
        font-size: 12px;
        opacity: 0.6;
        transition: opacity 0.2s;

        &:hover {
          opacity: 1;
        }
      }
    `,
  ],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(100%)', opacity: 0 }),
        animate('300ms ease-out', style({ transform: 'translateX(0)', opacity: 1 })),
      ]),
      transition(':leave', [animate('200ms ease-in', style({ transform: 'translateX(100%)', opacity: 0 }))]),
    ]),
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  protected scheduler = inject(NotificationScheduler);
  protected store = inject(NotificationStore);
}
